/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetUserSettingsResponse
 */
export interface GetUserSettingsResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetUserSettingsResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserSettingsResponse
     */
    sendPromotionalSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserSettingsResponse
     */
    sendTransactionalSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserSettingsResponse
     */
    sendCommunicationalSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserSettingsResponse
     */
    allowAutoPayment: boolean;
}

/**
 * Check if a given object implements the GetUserSettingsResponse interface.
 */
export function instanceOfGetUserSettingsResponse(value: object): value is GetUserSettingsResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('sendPromotionalSms' in value) || value['sendPromotionalSms'] === undefined) return false;
    if (!('sendTransactionalSms' in value) || value['sendTransactionalSms'] === undefined) return false;
    if (!('sendCommunicationalSms' in value) || value['sendCommunicationalSms'] === undefined) return false;
    if (!('allowAutoPayment' in value) || value['allowAutoPayment'] === undefined) return false;
    return true;
}

export function GetUserSettingsResponseFromJSON(json: any): GetUserSettingsResponse {
    return GetUserSettingsResponseFromJSONTyped(json, false);
}

export function GetUserSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'sendPromotionalSms': json['sendPromotionalSms'],
        'sendTransactionalSms': json['sendTransactionalSms'],
        'sendCommunicationalSms': json['sendCommunicationalSms'],
        'allowAutoPayment': json['allowAutoPayment'],
    };
}

export function GetUserSettingsResponseToJSON(json: any): GetUserSettingsResponse {
    return GetUserSettingsResponseToJSONTyped(json, false);
}

export function GetUserSettingsResponseToJSONTyped(value?: GetUserSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'sendPromotionalSms': value['sendPromotionalSms'],
        'sendTransactionalSms': value['sendTransactionalSms'],
        'sendCommunicationalSms': value['sendCommunicationalSms'],
        'allowAutoPayment': value['allowAutoPayment'],
    };
}

